<router-outlet>
</router-outlet>
<div kendoWindowContainer></div>